// const config = useRuntimeConfig();
const apiUrl = import.meta.env.VITE_API_URL

const endpoints = {
  publicMessageUrl: `${apiUrl}/publicMessage`,
}

export default endpoints
